import { getPlanesAcademicos } from '../components/SeleccionPlanAcademico';

export const populateStudentMetadata = (studentInfo, selectedPlan) => {

    if (!studentInfo) return;
    if (!studentInfo.grados) return;

    const getPlanData = (planId) => studentInfo.grados.filter((x) => x.programaKey === planId)[0];
    const planAcademico = (!selectedPlan) ? studentInfo.grados[0] : getPlanData(selectedPlan);

    const nombre = `${studentInfo.aPaterno} ${studentInfo.aMaterno} ${studentInfo.nombre}`;
    const matricula = studentInfo.matricula;
    const campus = planAcademico.campusKey;
    const descrcampus = planAcademico.campus;
    const planActivo = `${planAcademico.programa}`;

    let planesActivos = getPlanesAcademicos(studentInfo);
    if (!planesActivos) planesActivos = [];
    const planCount = planesActivos.length;

    const studentMetadata = { nombre, matricula, campus, descrcampus, planActivo, planCount };

    localStorage.setItem("student_metadata", JSON.stringify(studentMetadata));
    setTimeout(() => { window.dispatchEvent(new CustomEvent("populateStudentMetadata", { detail: JSON.stringify(studentMetadata) })); }, 10);
};

export const getStudentMetadata = () => {
    const student_metadata_value = localStorage.getItem("student_metadata");

    // si el elemento no existe, retorna null
    if (!student_metadata_value) return null;

    const student_metadata = JSON.parse(student_metadata_value);
    return student_metadata;
};


export const saveMsToken = (token) => {
    localStorage.setItem("msToken", JSON.stringify(token));
    if (!token) localStorage.removeItem("msToken");
};

export const getMsToken= () => {
    const rawValue = localStorage.getItem("msToken");

    // si el elemento no existe, retorna null
    if (!rawValue) return null;

    const value = JSON.parse(rawValue);
    return value;
};